export const LOADING_EVENT = "LOADING_EVENT";
export const GET_EVENT_LIST = "GET_EVENT_LIST";
export const REMOVE_EVENT = "REMOVE_EVENT";
export const ADD_EVENT = "ADD_EVENT";
export const UPDATE_EVENT = "UPDATE_EVENT";
export const GET_EVENT_BYID = "GET_EVENT_BYID";